// import React, { useState } from 'react';

// const FormSelect4 = ({
//   getBankNameAndCode,
//   payerBankName,
//   handleInputChange
// }) => {
//   const [searchTerm, setSearchTerm] = useState('');
//   const [isDropdownOpen, setDropdownOpen] = useState(false);

//   const filteredBanks = getBankNameAndCode && getBankNameAndCode.filter(bank =>
//     bank.name.toLowerCase().includes(searchTerm.toLowerCase())
//   );

//   const handleBankSelect = (bankName) => {
//     handleInputChange({ target: { name: 'payerBankName', value: bankName } });
//     setDropdownOpen(false);
//   };

//   return (
//     <div className="custom-select-container" style={{ position: 'relative', width: '100%', marginBottom: '2rem' }}>
//       <div 
//         className="dropdown-header" 
//         onClick={() => setDropdownOpen(!isDropdownOpen)}
//         style={{ padding: '10px', border: '1px solid #ccc', cursor: 'pointer', height: '55px', display: 'grid', alignItems: 'center', justifyItems: 'left'}}
//       >
//         {payerBankName || 'Select a Bank'}
//         <span style={{ transform: isDropdownOpen ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.3s ease', display: 'grid', alignItems: 'center', justifyItems: 'right', position: 'absolute', right: '10px'  }}>
//           ▼
//         </span>
//       </div>
//       {isDropdownOpen && (
//         <div 
//           className="dropdown-menu" 
//           style={{ position: 'absolute', width: '100%', border: '1px solid #ccc', backgroundColor: 'white', zIndex: 1  }}
//         >
//           <input
//             type="text"
//             placeholder="Search for a bank"
//             value={searchTerm}
//             onChange={(e) => setSearchTerm(e.target.value)}
//             className="search-input"
//             style={{ width: '100%', padding: '10px', boxSizing: 'border-box' }}
//           />
//           <div className="options" style={{ maxHeight: '200px', overflowY: 'auto' }}>
//             {filteredBanks.length > 0 ? (
//               filteredBanks.map((bank) => (
//                 <div
//                   key={bank.id}
//                   onClick={() => handleBankSelect(bank.name)}
//                   className="dropdown-option"
//                   style={{ padding: '10px', cursor: 'pointer', borderBottom: '1px solid #eee' }}
//                 >
//                   {bank.name}
//                 </div>
//               ))
//             ) : (
//               <div style={{ padding: '10px', textAlign: 'center' }}>No banks found</div>
//             )}
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default FormSelect4;

import React, { useState } from 'react';

const FormSelect4 = ({
  getBankNameAndCode,
  payerBankName,
  handleInputChange
}) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [isDropdownOpen, setDropdownOpen] = useState(false);

  const filteredBanks = getBankNameAndCode.filter(bank =>
    bank.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleBankSelect = (bankName) => {
    handleInputChange({ target: { name: 'payerBankName', value: bankName } });
    setDropdownOpen(false);
  };

  return (
    <div className="custom-select-container" style={{ position: 'relative', width: '100%', marginBottom: '2rem' }}>
      <div 
        className="dropdown-header" 
        onClick={() => setDropdownOpen(!isDropdownOpen)}
        style={{ padding: '10px', border: '1px solid #ccc', cursor: 'pointer', height: '55px', display: 'grid', alignItems: 'center', justifyItems: 'left'}}
      >
        {payerBankName || 'Select a Bank'}
        <span style={{ transform: isDropdownOpen ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.3s ease', display: 'grid', alignItems: 'center', justifyItems: 'right', position: 'absolute', right: '10px'  }}>
          ▼
        </span>
      </div>
      {isDropdownOpen && (
        <div 
          className="dropdown-menu" 
          style={{ position: 'absolute', width: '100%', border: '1px solid #ccc', backgroundColor: 'white', zIndex: 1  }}
        >
          <input
            type="text"
            placeholder="Search for a bank"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="search-input"
            style={{ width: '100%', padding: '10px', boxSizing: 'border-box' }}
          />
          <div className="options" style={{ maxHeight: '200px', overflowY: 'auto' }}>
            {filteredBanks.length > 0 ? (
              filteredBanks.map((bank) => (
                <div
                  key={bank.id}
                  onClick={() => handleBankSelect(bank.name)}
                  className="dropdown-option"
                  style={{ padding: '10px', cursor: 'pointer', borderBottom: '1px solid #eee' }}
                >
                  {bank.name}
                </div>
              ))
            ) : (
              <div style={{ padding: '10px', textAlign: 'center' }}>No banks found</div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default FormSelect4;
